/* eslint-disable react/jsx-props-no-spreading */
import { ReactNode } from 'react'
import MdButton from '@mui/material/Button'
import CircularProgress from '@mui/material/CircularProgress'
import makeStyles from '@mui/styles/makeStyles'

const useStyles = makeStyles({
  progress: {
    color: 'white'
  }
})

type Props = {
  children: ReactNode
  disabled?: boolean
  onClick: () => void
  loading?: boolean
  size?: 'large' | 'medium' | 'small'
}

export default function ButtonPrimary({
  children,
  loading,
  size = 'medium',
  ...rest
}: Props): JSX.Element {
  const classes = useStyles()

  return (
    <MdButton
      {...rest}
      type="button"
      color="primary"
      variant="contained"
      size={size}
      startIcon={loading ? <CircularProgress size={18} className={classes.progress} /> : null}
    >
      {children}
    </MdButton>
  )
}
